import { TurnStateEnum } from '../Enums/TurnStateEnum';

export class UpdateTurnStateRequest {
    static Message = 'UpdateTurnStateRequest';

    public gameId: string;
    public currentTurnState: TurnStateEnum;
    public wantedTurnState: TurnStateEnum;

    constructor(gameId: string, currentTurnState: TurnStateEnum, wantedTurnState: TurnStateEnum) {
        this.gameId = gameId;
        this.currentTurnState = currentTurnState;
        this.wantedTurnState = wantedTurnState;
    }
}

export class UpdateTurnStateResponse {
    static Message = 'UpdateTurnStateResponse';

    public newTurnState: TurnStateEnum;

    constructor(newTurnState: TurnStateEnum) {
        this.newTurnState = newTurnState;
    }
}
